import { useEffect, useState } from 'react';
import Award from './Award';
import Certificate from './Certificate';
import Contact from './Contact';
import Experience from './Experience';
import Introduction from './Introduction';
import Project from './Project';
import School from './School';
import Scientific from './Scientific';
import SocialLink from './SocialLink';
import Username from './Username';
import VolunteeringActivity from './VolunteeringActivity';
import Website from './Website';

import { useScreen } from '@/hooks/useScreen';
import {
  ModalType,
  UserSettingEnum,
} from '../../../interfaces/profile.interface';

interface IRenderUserSettingModal {
  modal: ModalType;
  cancelModal: (_refetch: boolean) => void;
}

const RenderUserSettingModal: React.FC<IRenderUserSettingModal> = ({
  modal,
  cancelModal,
  children,
}) => {
  const [isModalCancelled, setIsModalCancelled] = useState(false);
  const { isMobile } = useScreen();
  useEffect(() => {
    setIsModalCancelled(false);
    console.log(modal.name);
  }, [modal.name]);

  return (
    <>
      {/* 
      on mobile: no children is shown, no styles to worry about
      on desktop: there's another layout below modal, so we need additional
        styles to make modal float above all other components
    */}
      <div
        className={`block ${
          modal.isOpen ? 'md:bg-gray-700/50' : 'md:hidden'
        } md:fixed md:w-full md:h-full md:flex md:flex-col md:justify-center md:items-center md:z-[120]`}
        onClick={() => setIsModalCancelled(true)}
      >
        {modal.name === UserSettingEnum.Experience ? (
          <Experience
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Introduction ? (
          <Introduction
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.School ? (
          <School
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Scientific ? (
          <Scientific
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.SocialLink ? (
          <SocialLink
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Website ? (
          <Website
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Contact ? (
          <Contact
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Award ? (
          <Award
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Fullname ? (
          <Username
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Certificate ? (
          <Certificate
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Project ? (
          <Project
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : modal.isOpen && modal.name === UserSettingEnum.Volunteer ? (
          <VolunteeringActivity
            isModalCancelled={isModalCancelled}
            setIsModalCancelled={setIsModalCancelled}
            cancelCallback={cancelModal}
            defaultData={modal.value}
          />
        ) : (
          <div
            className="md:hidden"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {isMobile ? children : null}
          </div>
        )}
      </div>

      {/* 
      on mobile: chilren is shown only if no modal is opened
      on desktop: children is shown EVEN IF a modal is opened
    */}

      <div className="hidden md:block">{children}</div>
    </>
  );
};

export default RenderUserSettingModal;
